
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7076/api/',
    //Live
    apiUrl: 'https://cr-api.off-ease.com/api/',
   

    apiKey: 'Lieda1002',
};

export default apiConfig;

